//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { getIsInfluensterCampaignsEnabled } from '@legacy-components/nav3/navigation-menus/selectors/getIsInfluensterCampaignsEnabled';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export const SamplingNav = () => {
  const isInfluensterCampaignsEnabled = useSelector(
    getIsInfluensterCampaignsEnabled,
  );

  if (!isInfluensterCampaignsEnabled) {
    return null;
  }

  return (
    <NavMenuItem
      activeNavGroup={NavGroup.SAMPLING}
      state='sampling'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.SAMPLING_NAV}
    >
      Sampling
    </NavMenuItem>
  );
};
